import Vue from 'vue'
import './css/index.less'
import Passenger from '../extra-alone/components/addPassenger'
import { Button, Tabs, Icon, Select, Modal, message } from 'ant-design-vue'
import '@/assets/css/l8-model.less'
import moment from 'moment'
Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(Button)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Select)
Vue.use(Passenger)
Vue.use(Modal)
Vue.prototype.moment = moment
Vue.prototype.$message = message
